import PasswordItemRule from './password-item.rule';

export default class ExpectNumberRule extends PasswordItemRule {
    // https://codingbeautydev.com/blog/javascript-check-if-string-contains-numbers/#:~:text=To%20check%20if%20a%20string%20contains%20numbers%20in%20JavaScript%2C%20call,Otherwise%2C%20it%20will%20return%20false%20.&text=The%20RegExp%20test()%20method,regular%20expression%20and%20a%20string.
    containsNumbers(str) {
        return str.match(/\d/)!==null;
    }

    isValid() {
        return this.containsNumbers(this.password.element.value);
    }

    getRuleName() {
        return 'expect-number';
    }
}
